import React from 'react';

import SubAffiliatesApi from '../../../Api/CRM/Modules/SubAffiliatesApi';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import ViewButton from '../../elements/ViewButton';
import Card from '../../elements/common/Card';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import useAutoPaginator from '../../hooks/useAutoPaginator';
import {PERMISSION} from "../../helpers/Permissions";

function SubAffiliatesList() {
    const { items, updateItems, isLoading, auto } = useAutoPaginator((page, params) =>
        SubAffiliatesApi.getAll(page, { params })
    );

    function getLinks(id: number, modifyButtonsVisible: boolean) {
        return (
            <>
                <ViewButton url={`/sub-affiliates/${id}`} permissions={[PERMISSION.VIEW_SUB_AFFILIATE]} />
                {modifyButtonsVisible && (
                    <>
                        <EditButton url={`/sub-affiliates/${id}/edit`} permissions={[PERMISSION.UPDATE_SUB_AFFILIATE]} />
                        <DeleteButton
                            url={`/crea/api/sub_affiliate/${id}`}
                            action={updateItems}
                            permissions={[PERMISSION.DELETE_SUB_AFFILIATE]}
                        />
                    </>
                )}
            </>
        );
    }

    return (
        <Card title="All sub affiliates">
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <div />
                        <th>ID</th>
                        <th>Medium</th>
                        <th>Campaign</th>
                        <th>Content</th>
                        <th>Register count</th>
                    </TableHead>
                    <tbody>
                        {items.map((subAff) => (
                            <tr key={subAff.id}>
                                <td>{getLinks(subAff.id, subAff.register_count === 0)}</td>
                                <td>{subAff.id}</td>
                                <td>{subAff.medium}</td>
                                <td>{subAff.campaign}</td>
                                <td>{subAff.content}</td>
                                <td>{subAff.register_count}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

export default SubAffiliatesList;
